import { Component, inject } from '@angular/core';
import { AdvertisingFormComponent } from "../advertising-form/advertising-form.component";
import { AdvertisingService } from '../services/advertising.service';
import { AccessService } from '../../core/services/access.service';

@Component({
  selector: 'app-advertising-create',
  standalone: true,
  imports: [AdvertisingFormComponent],
  templateUrl: './advertising-create.component.html',
  styleUrl: './advertising-create.component.css'
})
export class AdvertisingCreateComponent {
  private service = inject(AdvertisingService)

  protected access = inject(AccessService).access

  constructor() {}

  ngOnInit(): void {
    this.service.title.update((value) => 'Nueva Pantalla');
  }
}
